export const AG_GRID_ICONS = {
    BOOKMARK_ICON: "BookMarkIcon",
    CHECKBOX_ICON: "checkboxIcon",
    FOLDER_ICON: "FolderIcon",
    IMAGE_ICON: "imageIcon",
    OPEN_NEW_TAB_ICON: "OpenInNewTabIcon",
    OPEN_FOLDER_ICON: "OpenFolderIcon",
    TRASH_ICON: "trashIcon",
};

export const AG_GRID_COLUMNS = {
    MERCHANT_NUMBER: "merchantNumber",
};